import React, { useState } from 'react'
import styles from './Our-faculty.module.css'
import { Box, Button, Link, Modal, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useRouter } from 'next/router';
import Head from 'next/head';

function OurFaculty() {
    //  ======== wheel modal =======
    const [open, setOpen] = useState(false);
  
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
  
    // comming soon ==============>
  
    const [newOpen, setNewOpen] = useState(false)
  
  
    const handleNewOpen = () => setNewOpen(true)
    const handleNewClose = () => setNewOpen(false)
  
    const router = useRouter()
  
    return (
      <>
  
        <Head>
          <title>Our Faculty | School of Divine Infinite Being</title>
          <meta name="viewport" content="width=device-width, initial-scale=1.0"></meta>
          <meta name="keywords" content="Divine Infinite Being, Spiritual Education, Astrology Certification, Tarot Course, Eddie Paredes, Tabatha Adams, Spiritual Guidance, Psychic Readings, Esoteric Knowledge, Spiritual Team, Astrological Insights, Transformative Experience, Spiritual Excellence"></meta>
          <meta name="description" content="Meet the distinguished faculty of the School of Divine Infinite Being, featuring experts in Tarot, Astrology, Philosophy, and more. Learn from seasoned practitioners and educators dedicated to spiritual growth and academic excellence."></meta>
          
          <meta property="og:title" content="Our Faculty | School of Divine Infinite Being"></meta>
          <meta property="og:type" content="website" ></meta>
          <meta property="og:image" content="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/dev-divineinfinitebeing-com-about_img.webp"></meta>
          <meta property="og:image:alt" content="Group photo of the faculty members at the School of Divine Infinite Being"></meta>
          <meta property="og:description" content="Meet the distinguished faculty of the School of Divine Infinite Being, featuring experts in Tarot, Astrology, Philosophy, and more. Learn from seasoned practitioners and educators dedicated to spiritual growth and academic excellence."></meta>
          
          <meta property="twitter:image" content="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/dev-divineinfinitebeing-com-about_img.webp"></meta>
          <meta property="twitter:image:alt" content="Explore the diverse team that makes up our faculty, dedicated to guiding students through their spiritual and academic journeys"></meta>
          <meta name="twitter:card" content="summary_large_image"></meta>
          <meta property="twitter:title" content="Our Faculty | School of Divine Infinite Being"></meta>
          <meta property="twitter:url" content="https://www.divineinfinitebeing.com/about"></meta>
          <meta property="twitter:description" content="Meet the distinguished faculty of the School of Divine Infinite Being, featuring experts in Tarot, Astrology, Philosophy, and more. Learn from seasoned practitioners and educators dedicated to spiritual growth and academic excellence."></meta>
          
          <meta property="og:image:width" content="1200"></meta>
          <meta property="og:image:height" content="627"></meta>
          <meta property="og:url" content="https://www.divineinfinitebeing.com/about"></meta>
          <link rel="canonical" href="https://www.divineinfinitebeing.com/about" />
        </Head>


        {/* <!------Main Banner section-------> */}
        <div className={styles.rotathewheelblockone}>
          <div className={styles.asmainwrapper}>
            <div className={styles.rotathewheelblockoneleft}>
              <span className={styles.bannerLogo}>
                <span className={styles.logoviewlink} onClick={handleOpen}>
                  {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/viewicon.png" /> */}
                  <img src={`${process.env.cloud_url2}assets/images/viewicon.png`} />
                </span>
                {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/logobanner.webp" /> */}
                <img src={`${process.env.cloud_url2}assets/images/logobanner.webp`} />
              </span>
              <h1 data-text="SCHOOL OF OUR DIVINE" >SCHOOL OF OUR DIVINE  </h1>
              <h1 data-text="infinite being">INFINITE BEING</h1>
  
              <h2>Polytheistic Monism - Divine Theurgy - Oracle to the Gods</h2>
              <div className={`${styles.rotathewheelbottombannerbg} ${styles.bannerboxtxt}`}></div>
            </div>
          </div>
        </div>
        {/* ===== Block1 ===== */}
        <div className={styles.ourT_block1}>
          <div className={`${styles.countDiv}  ${styles.titleblock}  ${styles.withsubtitle} `}>
            <span className={styles.column}>
              <div className={`${styles.col12}  ${styles.h_100}`}>
                <h1>OUR TEACHER</h1>
              </div>
            </span>
          </div>
          <div className={styles.new_master_main_wrapper}>
            <div className={styles.common_width}>
              <div className={styles.new_master_main_sub_wrapper}>
                <div className={styles.new_master_sub_wrapper}>
                  <div className={styles.new_master_left_sec}>
                    <div className={styles.new_master_left_img_sec}>
                      {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/our_teacher/Head_master.webp" /> */}
                      <img src={`${process.env.cloud_url}our_teacher/Head_master.webp`} />
                    </div>
                  </div>
                  <div className={`${styles.new_master_right_sec}  ${styles.none_sec}`}>
                    <h1>Eddie Paredes</h1>
                    <h2>School Head Master</h2>
                    <h2>Tarot/Astrology Instructor</h2>
                    <h2>Inner Mystery School Director</h2>
                    <p>Eddie Paredes, a dedicated teacher and practitioner of the Divine Infinite Being Method, serves as one of two instructors for the Astrology/Tarot certification course. As Head Master of the inner mystery school, he combines academic research with 20+ years of experiential practice. Passionate about diverse spiritual disciplines, Eddie's journey from exposure to esoteric and folk magic in his family's religion to developing a unique program reflects a lifelong commitment to self-discovery and wisdom.</p>
                    <Link href='/eddie-paredes'><Button className={styles.new_beto_btn}>Learn More</Button></Link>
                  </div>
  
                </div>
                <div className={styles.new_master_right_none_sec}>
                  <div className={styles.new_master_right_sec}>
  
                    <p>Eddie Paredes, a dedicated teacher and practitioner of the Divine Infinite Being Method, serves as one of two instructors for the Astrology/Tarot certification course. As Head Master of the inner mystery school, he combines academic research with 20+ years of experiential practice. Passionate about diverse spiritual disciplines, Eddie's journey from exposure to esoteric and folk magic in his family's religion to developing a unique program reflects a lifelong commitment to self-discovery and wisdom.</p>
                    <Link href='/eddie-paredes'><Button className={styles.new_beto_btn}>Learn More</Button></Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.common_width}>
            <div className={styles.B1_teachers}>
              <div className={`${styles.b1_teacher_box}  ${styles.beto_paredes_blk}`}>
                <div className={styles.B1_teachers_inner_box_image}>
                  <div className={styles.B1_teachers_inner_box_sub_img_wrpr}>
                    {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/our_teacher/Head_master.webp" /> */}
                    {/* <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/our_teacher/timothy_man_img.webp'/> */}
                    <img src={`${process.env.cloud_url}our_teacher/timothy_man_img.webp`} />
  
                  </div>
                </div>
                <div className={styles.B1_teachers_inner_box_text} >
                  <h1>TIMOTHY DESMOND</h1>
                  <h2>Philosophy Program
                    Director</h2>
                  <h2>Psyche and Singularity
                    Instructor</h2>
                </div>
                <div className={styles.B1_teachers_inner_box_text2}>
                  <p>Timothy (Tod) Owen Desmond teaches philosophy, religion, and ethics as an Adjunct Professor at The College of Southern Maryland. He earned a BA in Philosophy and Political Science from Boston College; a Master of Liberal Studies degree from Georgetown University; an MA in Political Science from the University of Hawai’i in Manoa, with a concentration in Alternative Futures Studies; and a Ph.D. in Philosophy and Religion from the California Institute of Integral Studies, with a specialization in Philosophy, Cosmology, and Consciousness.</p>
                  <Link href='/timothy-desmond'><Button >Learn More</Button></Link>
                </div>
              </div>
              <div className={`${styles.b1_teacher_box} ${styles.b1_tbox_modify}`}>
                <div className={styles.B1_teachers_inner_box_image}>
                  <div className={styles.B1_teachers_inner_box_sub_img_wrpr}>
                    {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/our_teacher/Senior_instructor.webp" /> */}
                    <img src={`${process.env.cloud_url}our_teacher/Senior_instructor.webp`} />
                  </div>
                </div>
                <div className={styles.B1_teachers_inner_box_text}>
                  <h1>Tabatha Adams</h1>
                  <h2>Astrology Program Director</h2>
                  <h2>Tarot/Astrology Instructor</h2>
                </div>
                <div className={styles.B1_teachers_inner_box_text2}>
                  <p>Tabatha Adams, an accomplished astrologer, tarot reader, and psychic, holds two astrological certifications, having read over 5000 charts. Based in Utah, she reads at The Mystic Frog, contributes to The Pagan Chronicle, and manages the Utah Pagan Market. With eight years of experience, Tabby combines her vast knowledge and insights from beyond to provide clarity, healing, and guidance. Offering various astrology services, including natal charts and solar return readings, as well as tarot readings with different spreads, she tailors her approach to meet individual needs. Contact her for a transformative experience. </p>
                  <Button onClick={() => router.push('/witchy-tabby')}>Learn More</Button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.immorality_main_wrapper}>
          <div className={styles.common_width}>
            <div className={styles.immorality_main_sub_wrapper}>
              <div className={styles.immorality_main_sub_sec_wrapper}>
  <h1>IMMORTALITY</h1>
  <p>AND THE UNREALITY OF DEATH</p>
  <h3>A HERO’S JOURNEY THROUGH PHILOSOPHY, PSYCHOLOGY, AND PHYSICS</h3>
  <h4>The ground breaking course by Professor <span>Timothy Desmond Ph.D.</span> that will change the way you see reality forever. Over 14 hours across 300 segments comprising a total of 78 training sessions.</h4>
  <Link href='https://psycheandsingularity.com/purchase' target="_blank" ><button className={styles.immorality_btn}>GET INSTANT ACCESS TO THIS CLASS RIGHT AWAY!</button></Link>
  
  </div>
            </div>
  
          </div>
        </div>
        {/* <div className={styles.immorality_sec}>
          <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/our_teacher/our_teachers_immorality_blk.webp' />
          <Link href='https://dev.timothydesmond.influxiq.com/purchase' className={styles.blank_link}></Link>
  
        </div> */}
        {/* ===== Block1 end ===== */}
        {/* ===== Block2 ===== */}
        <div className={styles.ourT_block2}>
          <div className={styles.common_width}>
            <div className={styles.ourT_block2_wrpr}>
              {/* ===== blocks ===== */}
              <div className={`${styles.ourT_b2_teacher_box}`}>
                <div className={`${styles.ourT_b2_teacher_sub_box}`}>
                  <div className={styles.ourT_b2_T_image}>
                    {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/our_teacher/SubhraBitanGhatak.webp" /> */}
                    <img src={`${process.env.cloud_url}our_teacher/SubhraBitanGhatak.webp`} />
                  </div>
                  <div className={styles.ourT_b2_T_text}>
                    <h1>Subhra Bitan Ghatak</h1>
                    <h2>Executive Administrator</h2>
                  </div>
                </div>
              </div>
  
              <div className={`${styles.ourT_b2_teacher_box} ${styles.ourT_b2_red_box}`}>
                <div className={`${styles.ourT_b2_teacher_sub_box}`}>
                  <div className={styles.ourT_b2_T_image}>
                    {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/our_teacher/RAJU_SARKAR.webp" /> */}
                    <img src={`${process.env.cloud_url}our_teacher/RAJU_SARKAR.webp`} />
                  </div>
                  <div className={styles.ourT_b2_T_text}>
                    <h1>RAJU SARKAR</h1>
                    <h2>Executive Artist</h2>
                  </div>
                </div>
              </div>
  
              <div className={`${styles.ourT_b2_teacher_box} ${styles.ourT_b2_Green_box}`}>
                <div className={`${styles.ourT_b2_teacher_sub_box}`}>
                  <div className={styles.ourT_b2_T_image}>
                    {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/our_teacher/DEBASIS_KAR.webp" /> */}
                    <img src={`${process.env.cloud_url}our_teacher/DEBASIS_KAR.webp`} />
                  </div>
                  <div className={styles.ourT_b2_T_text}>
                    <h1>DEBASIS KAR</h1>
                    <h2>Chief Engineer</h2>
                  </div>
                </div>
              </div>
  
              <div className={`${styles.ourT_b2_teacher_box} ${styles.ourT_b2_Green_box}`}>
                <div className={`${styles.ourT_b2_teacher_sub_box}`}>
                  <div className={styles.ourT_b2_T_image}>
                    {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/our_teacher/SOMNATH_SARKAR.webp" /> */}
                    <img src={`${process.env.cloud_url}our_teacher/SOMNATH_SARKAR.webp`} />
                  </div>
                  <div className={styles.ourT_b2_T_text}>
                    <h1>SOMNATH <br /> SARKAR</h1>
                    <h2>Graphic And Web Designer</h2>
                  </div>
                </div>
              </div>
  
              <div className={`${styles.ourT_b2_teacher_box}`}>
                <div className={`${styles.ourT_b2_teacher_sub_box}`}>
                  <div className={styles.ourT_b2_T_image}>
                    {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/our_teacher/SUBHANKAR_PAUL.webp" /> */}
                    <img src={`${process.env.cloud_url}our_teacher/SUBHANKAR_PAUL.webp`} />
                  </div>
                  <div className={styles.ourT_b2_T_text}>
                    <h1>SUBHANKAR <br /> PAUL</h1>
                    <h2>Graphic And Web Designer</h2>
                  </div>
                </div>
              </div>
  
              <div className={`${styles.ourT_b2_teacher_box} ${styles.ourT_b2_red_box}`}>
                <div className={`${styles.ourT_b2_teacher_sub_box}`}>
                  <div className={styles.ourT_b2_T_image}>
                    {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/our_teacher/Nilanjan_Sarkar.webp" /> */}
                    <img src={`${process.env.cloud_url}our_teacher/Nilanjan_Sarkar.webp`} />
  
                  </div>
                  <div className={styles.ourT_b2_T_text}>
                    <h1>Nilanjan <br /> Sarkar</h1>
                    <h2>Social Experience Specialist</h2>
                  </div>
                </div>
              </div>
  
              <div className={`${styles.ourT_b2_teacher_box} ${styles.ourT_b2_red_box}`}>
                <div className={`${styles.ourT_b2_teacher_sub_box}`}>
                  <div className={styles.ourT_b2_T_image}>
                    {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/our_teacher/Amitava_Das.webp" /> */}
                    <img src={`${process.env.cloud_url}our_teacher/Amitava_Das.webp`} />
                  </div>
                  <div className={styles.ourT_b2_T_text}>
                    <h1>Amitava Das</h1>
                    <h2>Interface Developer</h2>
                  </div>
                </div>
              </div>
  
              <div className={`${styles.ourT_b2_teacher_box} ${styles.ourT_b2_Green_box}`}>
                <div className={`${styles.ourT_b2_teacher_sub_box}`}>
                  <div className={styles.ourT_b2_T_image}>
                    {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/our_teacher/Avijit_Sau.webp" /> */}
                    <img src={`${process.env.cloud_url}our_teacher/Avijit_Sau.webp`} />
                  </div>
                  <div className={styles.ourT_b2_T_text}>
                    <h1>Avijit Sau</h1>
                    <h2>Interface Developer</h2>
                  </div>
                </div>
              </div>
  
              <div className={`${styles.ourT_b2_teacher_box} `}>
                <div className={`${styles.ourT_b2_teacher_sub_box}`}>
                  <div className={styles.ourT_b2_T_image}>
                    {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/our_teacher/Subhashis_Dutta.webp" /> */}
                    <img src={`${process.env.cloud_url}our_teacher/Subhashis_Dutta.webp`} />
                  </div>
                  <div className={styles.ourT_b2_T_text}>
                    <h1>Subhashis <br /> Dutta</h1>
                    <h2>Interface Developer</h2>
                  </div>
                </div>
              </div>
  
              <div className={`${styles.ourT_b2_teacher_box} `}>
                <div className={`${styles.ourT_b2_teacher_sub_box}`}>
                  <div className={styles.ourT_b2_T_image}>
                    {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/our_teacher/Soumyabrata_Karmakar.webp" /> */}
                    <img src={`${process.env.cloud_url}our_teacher/Soumyabrata_Karmakar.webp`} />
                  </div>
                  <div className={styles.ourT_b2_T_text}>
                    <h1>Soumyabrata Karmakar</h1>
                    <h2>Software Developer</h2>
                  </div>
                </div>
              </div>
  
              <div className={`${styles.ourT_b2_teacher_box} ${styles.ourT_b2_red_box}`}>
                <div className={`${styles.ourT_b2_teacher_sub_box}`}>
                  <div className={styles.ourT_b2_T_image}>
                    {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/our_teacher/Arnab_Pramanick.webp" /> */}
                    <img src={`${process.env.cloud_url}our_teacher/Arnab_Pramanick.webp`} />
                  </div>
                  <div className={styles.ourT_b2_T_text}>
                    <h1>Arnab Pramanick</h1>
                    <h2>Software Developer</h2>
                  </div>
                </div>
              </div>
  
              <div className={`${styles.ourT_b2_teacher_box} ${styles.ourT_b2_Green_box}`}>
                <div className={`${styles.ourT_b2_teacher_sub_box}`}>
                  <div className={styles.ourT_b2_T_image}>
                    {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/our_teacher/Sanket_Biswas.webp" /> */}
                    <img src={`${process.env.cloud_url}our_teacher/Sanket_Biswas.webp`} />
                  </div>
                  <div className={styles.ourT_b2_T_text}>
                    <h1>Sanket Biswas</h1>
                    <h2>Software Developer</h2>
                  </div>
                </div>
              </div>
  
  
            </div>
          </div>
        </div>
        {/* ===== Block2 end ===== */}
  
  
  
        {/* =============== wheel modal ================ */}
  
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          className="banner_modal_main"
        >
          <Box className="banner_modal_box">
            <Typography
              id="modal-modal-description" component="div"
              sx={{ mt: 2 }}
              className="modal_banner"
            >
              <div className="sub_modal_banner">
                <span className="close_btn" onClick={handleClose}>
                  <CloseIcon />
                </span>
                {/* <img
                  src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/logobanner.webp"
                  alt="bannerLogo"
                /> */}
                <img src={`${process.env.cloud_url2}assets/images/logobanner.webp`} />
              </div>
            </Typography>
          </Box>
        </Modal>
  
  
        {/* ============= comming soon modal ===================== */}
  
        <Modal
          open={newOpen}
          onClose={handleNewClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          className='banner_modal_main'
        >
          <Box className='banner_modal_box_new'>
  
            <Typography id="modal-modal-description" component="div" sx={{ mt: 2 }} className="modal_banner_new">
              <div className='sub_modal_banner'>
                <span className='close_btn' onClick={handleNewClose}><CloseIcon /></span>
                <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/logobanner.webp" alt="bannerLogo" />
                <p className='modal_commingsoon'>Coming soon</p>
              </div>
            </Typography>
          </Box>
        </Modal>
  
  
      </>
    )
  }

export default OurFaculty